<template>
  <div class=""></div>
</template>

<script>
export default {
  name: "icon-options-data"
}
</script>

<style scoped>
.no-break {
  word-break: keep-all;
}
.text-inp {
  max-width: 236px;
  width: calc(100% - 50px);
}
</style>
